import { Pipe, PipeTransform } from '@angular/core';
import { ManualComplianceStatus } from '../shared/enums/compianceStatus';

@Pipe({
  standalone: false,
  name: 'manualComplianceLabel',
})
export class ManualComplianceLabelPipe implements PipeTransform {
  transform(value: ManualComplianceStatus | string): string {
    const labels: { [key in ManualComplianceStatus]: string } = {
      [ManualComplianceStatus.Compliant]: 'Compliant',
      [ManualComplianceStatus.NonCompliant]: 'Non-Compliant',
      [ManualComplianceStatus.RiskRelease]: 'Risk Release',
      [ManualComplianceStatus.RiskReleaseAllIn]: 'All-In',
      [ManualComplianceStatus.AffordableHousing]: 'Affordable Housing',
      [ManualComplianceStatus.NotAvailable]: 'Not Available',
      [ManualComplianceStatus.Ineligible]: 'Ineligible',
      [ManualComplianceStatus.ThirdParty]: 'Third Party',
    };

    return labels[value as ManualComplianceStatus] || 'Unknown Status';
  }
}
